// @flow

import * as React from "react";

import { parse, format } from "date-fns";

import TicketAccordionForm from "../molecules/TicketAccordionForm";

type PropsType = {
    products?: [any],
    title?: string | React.Node,
    description?: string,
    onUpdate?: (any, any) => void,
    customRef?: any,
};

const TicketAccordionsForm = (props: PropsType): React.Node => {
    const [values, setValues] = React.useState(
        props.products?.map(product => ({
            id: product.product_id,
            qty: product.current_stock_quantity,
            price: product.price,
            available_from: format(
                parse(product.available_from, "yyyy-MM-dd HH:mm:ss", new Date()),
                "yyyy-MM-dd'T'HH:mm"
            ),
            available_until: format(
                parse(product.available_to, "yyyy-MM-dd HH:mm:ss", new Date()),
                "yyyy-MM-dd'T'HH:mm"
            ),
        })) || []
    );
    const formInstances = React.useRef([]);

    const validateForms = () => {
        formInstances.current?.forEach(form => {
            form.submit();
        });
    };
    if (props.customRef && props.customRef.current) {
        props.customRef.current.validateForm = validateForms;
    }

    return (
        <div className="accordions">
            <div className="accordions__content">
                {props.products &&
                    props.products?.map(
                        (product: any, i: number): React.Node => (
                            <TicketAccordionForm
                                key={i}
                                formRef={instance => {
                                    formInstances.current[i] = instance;
                                }}
                                title={`Ticket type ${i + 1} - ${
                                    product.crm_ticket_name
                                }`}
                                defaultValue={values[i]}
                                onUpdate={value => {
                                    const formattedValue = {
                                        ...value,
                                        available_from: value?.available_from
                                            ? format(
                                                  parse(
                                                      value.available_from,
                                                      "yyyy-MM-dd'T'HH:mm",
                                                      new Date()
                                                  ),
                                                  "yyyy-MM-dd HH:mm:ss"
                                              )
                                            : undefined,
                                        available_until: value?.available_until
                                            ? format(
                                                  parse(
                                                      value.available_until,
                                                      "yyyy-MM-dd'T'HH:mm",
                                                      new Date()
                                                  ),
                                                  "yyyy-MM-dd HH:mm:ss"
                                              )
                                            : undefined,
                                        qty: value?.qty
                                            ? Number(value.qty)
                                            : undefined,
                                        price: value?.price
                                            ? Number(value.price)
                                            : undefined,
                                    };
                                    const newValues = [...values];
                                    newValues[i] = formattedValue;
                                    setValues(newValues);

                                    const formValid =
                                        formInstances.current.every(
                                            form => form.formValid
                                        );

                                    props.onUpdate?.(newValues, formValid);
                                }}
                            />
                        )
                    )}
            </div>
        </div>
    );
};

export default TicketAccordionsForm;
